import commaNumber from "comma-number";

export const FormatPriceBand = value => `$${commaNumber(value)}`;
